// src/layers/imagery/formatImageryDate.js
//
// Display formatting for "YYYY_MM" imagery acquisition dates, with an
// OPTIONAL day: "2025_06" → "Jun 2025", "2025_12_13" → "13 Dec 2025". Falls
// back to the raw string for anything that doesn't match either shape.
//
// Lives next to the imagery data model because the "YYYY_MM" convention is
// domain-specific — it's the acquisition_date format produced by
// groupFootprintsIntoSeries and consumed across the imagery UI.

const MONTHS = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
];

export function formatAcquisitionDate(d) {
  // "2025_06" -> "Jun 2025";  "2025_12_13" -> "13 Dec 2025".
  //
  // THE DAY IS OPTIONAL BECAUSE THE DATASET KEY'S IS. parseDatasetKey accepts
  // YYYY_MM with an optional _DD, so a collect can now be identified to the day
  // — which is what allows two collects in one month. This has to follow, or a
  // day-precision date falls through to the raw-string branch below and every
  // caller renders "2025_12_13" verbatim: TimeSlider, FollowModeHUD, SeriesRow,
  // ActiveLayers and MapView all format through here.
  //
  // The raw-string fallback is kept deliberately. It is what makes a malformed
  // or unexpected acquisition_date show up as itself rather than as a wrong
  // date, and it is why the day-precision case was legible rather than silent
  // when it first appeared.
  const m = /^(\d{4})_(\d{2})(?:_(\d{2}))?$/.exec(d ?? "");
  if (!m) return d ?? "";

  const month = MONTHS[parseInt(m[2], 10) - 1] ?? m[2];
  return m[3]
    ? `${parseInt(m[3], 10)} ${month} ${m[1]}`
    : `${month} ${m[1]}`;
}
